import { apiOSS } from "./apiOSS";

export const SANDBOX_PERSONA_NAMES = ["jane", "chris", "ollie", "andreas", "kyla"] as const;
export type SandboxPersonaName = (typeof SANDBOX_PERSONA_NAMES)[number];

export async function fetchSandboxPatientFirstName(patientId: string): Promise<string | undefined> {
  try {
    const resp = await apiOSS.get<{ firstName?: string }>(`/medical/v1/patient/${patientId}`);
    return resp.data.firstName;
  } catch (err) {
    console.error(
      `[sandbox-patient] fetchSandboxPatientFirstName failed patientId=${patientId} err=${String(
        err
      )}`
    );
    return undefined;
  }
}
